<template>
  <v-dialog v-model="show" persistent @keydown.esc="hide" width="600">
    <v-card style="overflow-x: hidden">
      <v-row align="center" class="px-5 pt-1">
        <v-col>
          <span v-if="selectedTool" class="headline">
            {{
              $t("tools.comment.title", { engravedId: selectedTool.engravedId })
            }}
          </span>
        </v-col>
        <v-col cols="auto">
          <v-btn color="grey" text large icon @click="hide">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-card-text style="max-height: 66vh; overflow-y: auto">
        <v-row
          v-for="comment in localComments"
          :key="comment.id"
          :justify="isMe(comment) ? 'end' : 'start'"
        >
          <v-tooltip :left="isMe(comment)" :right="!isMe(comment)">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                v-bind="attrs"
                v-on="on"
                class="my-1 chat-text-chip"
                :color="isMe(comment) ? 'primary' : ''"
              >
                <router-link
                  v-if="comment.employeeId && !isMe(comment)"
                  class="pr-2"
                  :to="{ name: 'employee', params: { id: comment.employeeId } }"
                >
                  {{ comment.employee | nameId }}
                </router-link>
                {{ comment.comment }}
              </v-chip>
            </template>
            <span>
              {{ comment.createdAt | dateTimeWithoutSeconds }}
            </span>
          </v-tooltip>
        </v-row>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-form style="width: 100%">
          <v-textarea
            v-model="comment"
            outlined
            hide-details="auto"
            auto-grow
            :label="$t('tools.comment.new')"
            rows="1"
            :rules="[rules.length]"
          />
        </v-form>
        <v-btn
          :disabled="!comment || comment.length > 2048"
          color="primary"
          class="ml-2"
          text
          @click="addComment"
          >{{ $t("dialog.save") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import AddToolCommentMutation from "@/graphql/mutation/tools/AddToolComment.gql";
export default {
  props: {
    selectedTool: {
      type: Object,
    },
    show: {
      type: Boolean,
    },
  },
  data() {
    return {
      comment: "",
      localComments: [],
      rules: {
        length: (value) => {
          if (!value) return true;
          return (
            (value && value.length <= 2048) ||
            this.$t("validation.length", { n: 2048 })
          );
        },
      },
    };
  },
  watch: {
    selectedTool(tool) {
      const t = tool || {};
      this.localComments = t.comments ? [...t.comments] : [];
    },
  },
  computed: {
    ...mapState(["me"]),
  },
  methods: {
    isMe(comment) {
      return this.me.id === comment.employeeId;
    },
    hide() {
      this.$emit("update:show", false);
      this.comment = "";
    },
    addComment() {
      this.$apollo
        .mutate({
          mutation: AddToolCommentMutation,
          variables: {
            toolId: this.selectedTool.id,
            comment: this.comment,
          },
        })
        .then((result) => {
          const newComment = result.data.addToolComment;
          this.localComments.push(newComment);
          this.comment = "";
          this.$emit("refresh");
        })
        .catch((err) => {
          this.$store.commit("push_global_message", {
            color: "error",
            text: `${this.$t("error.saveFailed")}: ${err}`,
          });
        });
    },
  },
};
</script>

<style scoped>
.chat-text-chip {
  min-height: 32px;
  height: 100%;
  white-space: normal;
  line-height: unset;
  border-radius: 16px;
}
</style>
